import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import useFetch from "../../../../hooks/useAxios";
import Button from "../../../shared/Button";
import Input from "../../../shared/Input";
import Modal from "../../../shared/Modal";

const AddFaqCat = ({ closeModal, apiCatlist }) => {
  const [CatName, setCatName] = useState();
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset
  } = useForm();
  const postCategoriesFaq = useFetch({
    method: "post",
    url: "api/faq_categories/store",
    noHeader: false,
    trigger: false,
    data: CatName,
    caller: apiCatlist,
    argFunc: res => {
      toast.success("دسته بندی اضافه شد.");
      closeModal();
    }
  });
  const onSubmit = data => {
    setCatName({ ...data });
  };
  useEffect(
    () => {
      if (CatName) {
        postCategoriesFaq.reFetch();
      }
    },
    [CatName]
  );

  return (
    <div className="ModalBackground WageForAllRes">
      <div className="ModalBackground--container p-[32px]">
        <h3 className="text-[#00A6A6] text-[24px] font-[700]">اضافه کردن دسته بندی</h3>
     
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="text-[#292D32] text-[20px] font-[700]">
           دسته بندی
          </div>
          <div className="WageForAllRes--row">
            <Input
              name="title"
              control={control}
              errors={errors}
           
              className="secondary-input my-[20px]"
              register={{
                required: "  نام دسته بندی اجباری است"
              }}
            />
            <Button varient="secondary">اعمال</Button>
          </div>
        </form>
        <Button
          onClick={closeModal}
          varient="primary"
          fullwidth
          className="mt-[12px]"
        >
          انصراف
        </Button>
      </div>
    </div>
  );
};

export default AddFaqCat;
